// extracted by mini-css-extract-plugin
module.exports = {"grid":"src-FrequentAddressQueryPage-___FrequentAddressQueryPage-module__grid___2Ub-x"};